import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function CloseIcon({ size = '14px', className }: IIconProps) {
  return (
    <IconWrapper size={size} className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 4.5L4.5 15.5M15.5 15.5L4.5 4.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
